import { Injectable } from '@angular/core';
import { Observable, of, timer } from 'rxjs';
import { catchError, concatMap, mergeMap } from 'rxjs/operators';
import {
  AuthAccessTokenDetails,
  ILoginUserNamePasswordInput,
  LoginAuthWithCredentialsResponse,
  LoginOAuthParams,
  LoginOAuthResponse,
  SwapAuthForAccessTokens
} from '../../models/login';
import { getResponseId } from '../../utils/login/initiate-login-utils';
import { InitiateLoginFacadeHelperService } from './initiate-login-facade-helper.service';

@Injectable({
  providedIn: 'root'
})
export class InitiateLoginFacadeService extends InitiateLoginFacadeHelperService {
  initiateLogin(
    loginOAuthParams: LoginOAuthParams,
    requestInput?: ILoginUserNamePasswordInput,
    appToken = false,
    eamAuthStateValue?: string,
    forcePromptLoginFlow = false
  ): Observable<AuthAccessTokenDetails | boolean | string> {
    this.postWithCredentialsFacade.pkceCode = loginOAuthParams.pkceCode;
    return this.loginAuthorization
      .loginAuthorization(
        loginOAuthParams,
        eamAuthStateValue,
        forcePromptLoginFlow
      )
      .pipe(
        concatMap((response: LoginOAuthResponse) => {
          this.postWithCredentialsFacade.flowId = getResponseId(response);
          return this.handleAuthorizationResponse(response, loginOAuthParams);
        }),
        concatMap(
          (
            response: LoginAuthWithCredentialsResponse | SwapAuthForAccessTokens
          ) => {
            return this.handleCredentialsResponse(
              response,
              loginOAuthParams,
              requestInput
            );
          }
        ),
        concatMap(
          (
            response:
              | LoginAuthWithCredentialsResponse
              | SwapAuthForAccessTokens
              | AuthAccessTokenDetails
              | string
              | boolean
          ) => {
            return this.processResponse(response, loginOAuthParams, appToken);
          }
        ),
        catchError((error) => {
          if (typeof error === 'string') {
            return of(error);
          } else {
            return timer(
              loginOAuthParams.oauthConfig.LOGIN_RETRY_TIMER
                ? loginOAuthParams.oauthConfig.LOGIN_RETRY_TIMER
                : 1000
            ).pipe(
              mergeMap(() => {
                this.retryCount = this.retryCount + 1;
                if (
                  this.retryCount !==
                  loginOAuthParams.oauthConfig.LOGIN_RETRY_COUNT
                    ? loginOAuthParams.oauthConfig.LOGIN_RETRY_COUNT
                    : 0
                ) {
                  loginOAuthParams.pkceCode =
                    this.loginRememberMeUtils.generateCodeChallenge();
                  return this.initiateLogin(loginOAuthParams, requestInput);
                } else {
                  this.retryCount = 0;
                  return of(
                    this.loginRememberMeErrorUtil.checkRememberMeErrors(
                      loginOAuthParams.oauthConfig,
                      error
                    )
                  );
                }
              })
            );
          }
        })
      );
  }
}
